import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Button, { ButtonVariant, ButtonSize } from 'components/Button';
import { notify } from 'components/notification/notificationSlice';
import { useAppDispatch, useAppSelector } from 'hooks';

import { setShowErrors } from './Progress/progressSlice';
import { getOnboardingTabCode } from '../selectors';

type OnboardingTabActionsProps = {
  onSave?: () => any;
  onCancel?: () => void;
  isActionsDisabled?: boolean;
};

const OnboardingTabActions: React.FC<OnboardingTabActionsProps> = ({
  onSave,
  onCancel,
  isActionsDisabled,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common');

  const currentTabCode = useAppSelector(getOnboardingTabCode);

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (onSave) {
      setLoading(true);
      const result = await onSave();

      if (!result.error) {
        dispatch(
          notify({
            type: 'success',
            message: t('common:notifications.changesSubmitted'),
            duration: 3000,
          }),
        );

        dispatch(setShowErrors({ [currentTabCode]: true }));
      }

      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {onCancel && (
        <Button
          variant={ButtonVariant.secondaryOutline}
          size={ButtonSize.small}
          onClick={onCancel}
          disabled={isActionsDisabled}
          className="ml-1"
        >
          {t('common:cancel')}
        </Button>
      )}
      {onSave && (
        <Button
          variant={ButtonVariant.primary}
          size={ButtonSize.small}
          onClick={handleSave}
          disabled={isActionsDisabled}
          loading={loading}
          className="btn-save-changes"
        >
          {t('common:saveChanges')}
        </Button>
      )}
    </div>
  );
};

export default OnboardingTabActions;
